// checks if value is empty or null or undefined
export function isEmpty(value){
    return (value === undefined || value === null || value === '');
  }